import React, { useState } from "react";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";

export const images = [
  {
    src: "https://gbafilesalt.blob.core.windows.net/misc/ai-1_30.jpg",
    original: "https://gbafilesalt.blob.core.windows.net/misc/ai-1_30.jpg",
    width: 744,
    height: 458,
  },
  {
    src: "https://gbafilesalt.blob.core.windows.net/misc/ai-2_30.jpg",
    original: "https://gbafilesalt.blob.core.windows.net/misc/ai-2_30.jpg",
    width: 744,
    height: 458,
  },
];

function TrainingGallery() {
  const [index, setIndex] = useState(-1);

  const currentImage = images[index];
  const nextIndex = (index + 1) % images.length;
  const nextImage = images[nextIndex] || currentImage;
  const prevIndex = (index + images.length - 1) % images.length;
  const prevImage = images[prevIndex] || currentImage;

  const handleClick = (index, item) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  return (
    <>
      <Gallery
        images={images}
        onClick={handleClick}
        enableImageSelection={false}
      />

      {!!currentImage && (
        <Lightbox
          mainSrc={currentImage.original}
          imageTitle={currentImage.caption}
          mainSrcThumbnail={currentImage.src}
          nextSrc={nextImage.original}
          nextSrcThumbnail={nextImage.src}
          prevSrc={prevImage.original}
          prevSrcThumbnail={prevImage.src}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </>
  );
}

export default TrainingGallery;
